import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireArticle} from '@tisa-group/models';
import {Observable} from 'rxjs';

import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

@Injectable()
export class ArticleService implements CrudService<UmpireArticle> {
  constructor(readonly http: TisaUmpireHttpService) {}

  create(
    body: Partial<UmpireArticle>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireArticle>> {
    return this.http
      .post(`/articles`, serialize({stuff: body}), {
        params,
      })
      .pipe(deserialize());
  }

  delete(id: string, params?: JsonApiParams): Observable<void> {
    return this.http.delete(`/articles/${id}`, {params: objectToHttpParams(params)});
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireArticle>> {
    return this.http
      .get(`/articles/${fetchIdentifier}`, {
        params,
      })
      .pipe(deserialize());
  }

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireArticle[]>> {
    return this.http
      .get(`/articles`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireArticle>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireArticle>> {
    return this.http
      .patch(`/articles/${body?.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
